import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Loader, { LoaderType } from "../component/common-component/Loader";
import Nodata from "../component/common-component/Nodata";
import { useDispatch } from "react-redux";
import SubmitLoading from "../component/common-component/Loaders/SubmitLoading";
import { CompanyDetailsByCode } from "../services/ReduxTookit/Slice/ProjectTermRedux";
import MainpageLoader from "../component/common-component/Loaders/MainpageLoader";

const SubscriberTermsAndCondition = (props) => {
  const [subscribeerData, setSubscriberData] = useState(null);
  const [getSubscriberLoader, setGetSubscriberLoader] = useState(false);
  const [checkboxes, setCheckboxes] = useState({
    acceptTerms: false,
  });
  const dispatch = useDispatch();

  const getSubscriberDetailByPrimaryKey = async () => {
    setGetSubscriberLoader(true);
    let body = {
      id: props?.subscriberId ? parseInt(props?.subscriberId) : 0,
    };

    dispatch(CompanyDetailsByCode())?.then((response) => {
      if (response?.payload?.isValidate) {
        setSubscriberData(response?.payload?.data?.data);
        setGetSubscriberLoader(false);
      }
      if (!response?.payload?.isValidate) {
        setGetSubscriberLoader(false);
      }
    });
  };

  useEffect(() => {
    if (props?.subscriberId) {
      getSubscriberDetailByPrimaryKey();
    }
  }, [props?.subscriberId]);

  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxes((prev) => ({ ...prev, [name]: checked }));
  };

  const allChecked = checkboxes.acceptTerms;

  const CheckboxWithLoader = ({ id, name, label, viewType }) => (
    <div className="form-check checkbox-height">
      <input
        type="checkbox"
        className="form-check-input"
        id={id}
        name={name}
        checked={checkboxes[name]}
        onChange={handleCheckboxChange}
      />
      <label
        className="form-check-label termsconditionModal term-checkbox d-flex align-items-center gap-1"
        htmlFor={id}
      >
        {label + " "}
      </label>
    </div>
  );
  return (
    <div>
      {props?.loader && <MainpageLoader />}
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        // className="termsandcondition termsandcondition-modal"
        backdrop="static"
        scrollable
        className="terms-height"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Terms and Condition
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="mb-0">
          {getSubscriberLoader ? (
            <div className="pb-3">
              <Loader type={LoaderType.Line} count={9} />
            </div>
          ) : subscribeerData?.devclitermandconditions ? (
            <p
              dangerouslySetInnerHTML={{
                __html: subscribeerData?.devclitermandconditions
                  ? subscribeerData?.devclitermandconditions
                  : "No Data Found",
              }}
            />
          ) : (
            <Nodata />
          )}
          <CheckboxWithLoader
            id="acceptTerms"
            name="acceptTerms"
            label="Accept Terms & Conditions"
            viewType=""
          />
          {/* <div className="btn-box">
            <button
              className="grey-btn w-auto me-3"
              type="reset"
              disabled={props?.loader}
              onClick={props.onHide}
            >
              Reject
            </button>
            <button
              disabled={props?.loader}
              className="blue-btn w-auto"
              onClick={() => {
                // props.onHide();
                props.onsubmit();
              }}
            >
              {props?.loader ? (
                // <>
                //   <span>Loading</span>{" "}
                //   <Spinner
                //     className="ms-1"
                //     animation="border"
                //     role="status"
                //     size="sm"
                //   >
                //     <span className="visually-hidden">Loading...</span>
                //   </Spinner>
                // </>
                <SubmitLoading />
              ) : (
                "Accept"
              )}
            </button>
          </div> */}
        </Modal.Body>
        {/* <Modal.Footer>
        <button className="grey-btn w-auto" type="reset" onClick={props.onHide}>
          Close
        </button>
        <button disabled={props?.loader} onClick={()=>props.onsubmit()} className="blue-btn w-auto" type="submit">
        {props?.loader ? }Submit
        </button>
      </Modal.Footer> */}

        {/* <Form
        onSubmit={(e) => {
          handleSubmit(e);
        }}
      > */}

        {/* </Form> */}
        <Modal.Footer className="p-1">
          {/* <div className="btn-box"> */}
          {/* <button
              className="grey-btn w-auto me-3"
              type="reset"
              disabled={props?.loader}
              onClick={props.onHide}
            >
              Reject
            </button> */}
          <button
            disabled={!allChecked || props.loader}
            className={`${
              !allChecked || props.loader
                ? "disable-blue-btn w-auto"
                : "blue-btn w-auto "
            } btn-sm`}
            onClick={() => {
              props.onsubmit();
            }}
          >
            {props?.loader ? <SubmitLoading /> : "Accept"}
          </button>
          {/* </div> */}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default SubscriberTermsAndCondition;
